module.exports = __webpack_public_path__ + "static/media/Capture.b1daefc4.PNG";